import { render, staticRenderFns } from "./Thermometer.vue?vue&type=template&id=54903eb2"
import script from "./Thermometer.vue?vue&type=script&lang=js"
export * from "./Thermometer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports